import config from './config';

function getVpcsListApi(params) {
  return Ajax.get(config.listVpcs, params);	
}

export {
	getVpcsListApi
};


// WEBPACK FOOTER //
// ./src/api/privateNetwork/list/actions.js